import React, { useState } from "react";
import "./UserBike.css";

import SpecsSection from "../../Components/Specs/SpecsSection";
import GeometrySection from "../../Components/Geometry/GeometrySection";
import SetupSection from "../../Components/Setup/SetupSection";
import { getUserComponentsAPI } from "../../Services/PartService";
import { deleteUserBikeAPI, getGeoAPI, saveUserBikeAPI } from "../../Services/BikeService";
import { getSpecsAPI } from "../../Services/BikeService";

import PartsList from "../Parts/PartsList";
import { PartModel } from "../../Models/PartModel";
import { GeometryModel } from "../../Models/GeometryModel";
import { SpecsModel } from "../../Models/SpecsModel";
import { useAuth } from "../../Context/useAuth";
import { toast } from "react-toastify";
import ButtonSpinner from "../ButtonSpinner/ButtonSpinner";
import { UserBikeModel } from "../../Models/UserBikeModel";

interface Props {
  userBikeModel: UserBikeModel;
}

const Bike: React.FC<Props> = (props: Props): JSX.Element => {
  const [activeTab, setActiveTab] = useState("parts");
  const [showDetails, setShowDetails] = useState(false);
  const [componentsResult, setComponentsResult] = useState<PartModel[]>([]);
  const [geoResult, setGeoResult] = useState<GeometryModel>();
  const [specsResult, setSpecsResult] = useState<SpecsModel>();
  const { isLoggedIn, user, logout } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);

  const getComponents = (id: number) => {
    getUserComponentsAPI(id)
      .then((res) => {
        if (res?.data) {
          setComponentsResult(res?.data);
        }
      })
      .catch((e) => {
        setComponentsResult([]);
      });
  };

  const getGeo = (id: number) => {
    getGeoAPI(id)
      .then((res) => {
        if (res?.data) {
          setGeoResult(res?.data);
        }
      })
      .catch((e) => {
      });
  };
  const getSpecs = (id: number) => {
    getSpecsAPI(id)
      .then((res) => {
        if (res?.data) {
          setSpecsResult(res?.data);
        }
      })
      .catch((e) => {
      });
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "parts":
        return <PartsList parts={ componentsResult! }/>;
      case "specs":
        if (specsResult){
          return <SpecsSection specsModel={ specsResult }/>;
        }
        return "Specifications not found.";
      case "geometry":
        if (geoResult){
          return <GeometrySection geoModel={ geoResult }/>;
        }
        return  "Geometry not found.";
      case "setup":
        return <SetupSection />;
      default:
        return null;
    }
  };

const handleShowDetails = (id: number) => {
  getComponents(id);
  getGeo(id);
  getSpecs(id);
  setShowDetails(!showDetails);
};

const handleDelete = async (bike_id: number) => {
  setLoading(true);
  if (isLoggedIn() && user ){
    deleteUserBikeAPI(bike_id);
    toast.success("Success! Bike saved to garage");
  }
  else{
      toast.warning("Please login to save bike");
  }
  //TODO remove in production
  await new Promise(resolve => setTimeout(resolve, 500));
  setLoading(false);
}


  return (
    <div className="container mt-5 mb-5">
      <div className="card shadow-sm p-4">
        <div className="row align-items-center">
          <div className="col-md-5">
            <img
              src={ props.userBikeModel.image_url } className="hero-image p-0 img-fluid rounded"
              alt="Bike"
            />
          </div>
          <div className="col-md-4">
            <h3>{ props.userBikeModel.make }</h3>
            <p className="text-muted">{ props.userBikeModel.year } { props.userBikeModel.model }</p>
          </div>
          <div className="col-md-3">
            <div className="d-grid gap-2 col-12 mx-auto">
              <button 
                className="btn btn-primary mt-3" 
                onClick={() => handleShowDetails(props.userBikeModel.id)}
              >
                {showDetails ? "Hide Details" : "Show Details"}
              </button>
              {loading ? (<ButtonSpinner />) : (
                <button className="btn btn-danger mt-3" 
                        onClick={() => handleDelete(props.userBikeModel.id)}>
                  Remove from Garage
                </button>
              )}
            </div>
          </div>
        </div>

        {showDetails && (
          <>
            <ul className="nav nav-tabs mt-4" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "parts" ? "active" : ""}`}
                  onClick={() => setActiveTab("parts")}
                >
                  Parts
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "geometry" ? "active" : ""}`}
                  onClick={() => setActiveTab("geometry")}
                >
                  Geometry
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "specs" ? "active" : ""}`}
                  onClick={() => setActiveTab("specs")}
                >
                  Specs
                </button>
              </li>
              {/* <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "setup" ? "active" : ""}`}
                  onClick={() => setActiveTab("setup")}
                >
                  Setup
                </button>
              </li>
              */}
            </ul>

            <div className="tab-content border-top-0 p-3">
              {renderTabContent()}
            </div>
            </>
            )}
          </div>
    </div>
  );
};

export default Bike;
